/* src/app/components/dialogs/upload-folder-dialog/upload-folder-dialog.component.scss */
mat-dialog-content {
  margin: 0 20px;
  width: 450px;
  height: 100%;
  padding-bottom: 16px;
}
mat-form-field {
  --mat-form-field-container-height: 48px;
  --mat-form-field-filled-label-display: none;
  --mat-form-field-container-vertical-padding: 12px;
  --mat-form-field-filled-with-label-container-padding-top: 12px;
  --mat-form-field-filled-with-label-container-padding-bottom: 12px;
}
/*# sourceMappingURL=upload-folder-dialog.component.css.map */
